export enum EventStatus {
  PAST = 'PAST',
  FUTURE = 'FUTURE',
  CURRENT = 'CURRENT',
  NOT_FOUND = 'NOT_FOUND',
  FETCHING = 'FETCHING',
}
